import React from 'react';
import './style.scss';
import MetaInfo from './MetaInfo/MetaInfo';
import imgHero from './i/cheese_hero.jpg';
import imgHeroMobile from './i/mobile/cheese_hero.jpg';
import arrow from '../../../../assets/images/hero-arrow.png';
import { TranslatableText } from '../../../../providers/LanguageProvider';
import SliderWrap from '../../../../components/SliderWrap/SliderWrap';
import slide1 from './i/carousel_cheese_1.jpg';
import slide2 from './i/carousel_cheese_2.jpg';
import slide3 from './i/carousel_cheese_3.jpg';
import slide4 from './i/carousel_cheese_4.jpg';
import slide5 from './i/carousel_cheese_5.jpg';
import Icon from '../../../../components/Icon/Icon';
import { Link } from 'react-router-dom';
import IngredientsSlider from '../../../../components/IngredientsSlider/IngredientsSlider';
import MobileOrderBanner from '../../../../components/MobileOrderBanner/MobileOrderBanner';

const Cheese = (props) => {

    return (
        <>
            <MetaInfo {...props} />
            <div className="blockwrap our-food-pages cheese">

                <div className="intro-block">
                    {props.isDesktop ? 
                        <img className="intro-bg-img" src={imgHero} alt="cheese" />
                        : 
                        <img className="intro-bg-img" src={imgHeroMobile} alt="cheese" />
                    }
                </div>

                <div className="copy-block">
                    <h1><span><span className="line"></span><TranslatableText dictionary={{ "en": "Our", "fr": "Notre"}} ></TranslatableText><span className="line"></span></span><TranslatableText dictionary={{ "en": "Cheese", "fr": "fromage"}} ></TranslatableText></h1>

                    {props.lang === 'en' && <p>Simple, natural ingredients make the best food. That’s why we've officially ditched processed cheese. All our cheese—cheddar, cheese curds and mozzarella—is 100% real and made with 100% Canadian milk.</p>}
                    {props.lang === 'fr' && <p>Chez A&W, nous croyons en l’utilisation de vrais ingrédients. C’est pourquoi nous avons officiellement éliminé le fromage transformé. Tous nos fromages – cheddar, mozzarella et en grains – sont 100 % naturels et faits avec du lait 100 % canadien.</p>}
                    <img src={arrow} className="bounce" alt="arrow" />
                </div>

            </div>

             <div className="where-block cheese">
                            
                { props.lang !== 'fr' ?
                    <> 
                        <h2>Here’s how we make&nbsp;  
                            <span>our real cheddar cheese:</span>
                        </h2>
                    </>
                    :
                    <> 
                        <h2>Voici comment notre&nbsp;  
                            <span>vrai fromage cheddar est fait :</span>
                        </h2>
                    </>
                }
            </div>

            <SliderWrap {...props}>
                <div key="1" className="item">
                    <div className="itemcol">
                        <img src={slide1} className="" alt="" /> 
                        <div className="copy-wrap">
                            {props.lang !== 'fr' ? 
                                    <>
                                        <h3>Step 1</h3>
                                        <p>Milk is collected from Canadian dairy cows.</p>
                                    </>
                                :
                                    <>
                                        <h3>Étape 1</h3>
                                        <p>Le lait provient de vaches laitières canadiennes.</p>
                                    </>
                            }
                        </div>
                    </div>
                </div>
                <div key="2" className="item">
                    <div className="itemcol">
                        <img src={slide2} className="" alt="" /> 
                        <div className="copy-wrap">
                            {props.lang !== 'fr' ? 
                                    <>
                                        <h3>Step 2</h3>
                                        <p>Starter culture is stirred into the fresh milk to create cheese curds.</p>
                                    </>
                                :
                                    <>
                                        <h3>Étape 2</h3>
                                        <p>La culture bactérienne est mélangée avec du lait frais pour créer des grains de fromage.</p>
                                    </>
                            }
                        </div>
                    </div>
                </div>
                <div key="3" className="item">
                    <div className="itemcol">
                        <img src={slide3} className="" alt="" /> 
                        <div className="copy-wrap">
                            {props.lang !== 'fr' ? 
                                    <>
                                        <h3>Step 3</h3>
                                        <p>Cheese curds are pressed together to form blocks of real cheddar cheese.</p>
                                    </>
                                :
                                    <>
                                        <h3>Étape 3</h3>
                                        <p>Les grains sont pressés ensemble pour former des blocs de cheddar.</p>
                                    </>
                            }
                        </div>
                    </div>
                </div>
                <div key="4" className="item">
                    <div className="itemcol">
                        <img src={slide4} className="" alt="" /> 
                        <div className="copy-wrap">
                            {props.lang !== 'fr' ? 
                                    <>
                                        <h3>Step 4</h3>
                                        <p>The cheddar cheese is naturally aged for over 6 weeks to get that perfect medium cheddar flavour.</p>
                                    </>
                                :
                                    <>
                                        <h3>Étape 4</h3>
                                        <p>Le cheddar est vieilli à la perfection pendant plus de six semaines.</p>
                                    </>
                            }
                        </div>
                    </div>
                </div>
                <div key="5" className="item">
                    <div className="itemcol">
                        <img src={slide5} className="" alt="" /> 
                        <div className="copy-wrap">
                            {props.lang !== 'fr' ? 
                                    <>
                                        <h3>Step 5</h3>
                                        <p>The cheddar is sliced and delivered to A&W restaurants across Canada where it is happily devoured.</p>
                                    </>
                                :
                                    <>
                                        <h3>Étape 5</h3>
                                        <p>Le cheddar est tranché et livré dans les restaurants A&W partout au pays, où il peut enfin être savouré.</p>
                                    </>
                            }
                        </div>
                    </div>
                </div>

            </SliderWrap>

            <div className="blockwrap our-food faq-block cheese">
            
                <Link  className="find-aw"  to={`/${props.lang}/faq/cheese`}>
                    {props.lang !== 'fr' ? 
                        <><span></span> FAQ<Icon type=" gt-inverted" /></>
                        :
                        <><span>FAQ </span><Icon type=" gt-inverted" /></>
                    }
                </Link>

            </div>

            <IngredientsSlider currentPage="cheese" {...props} />
            <MobileOrderBanner {...props} />

        </>

    )
}
export default Cheese;